import { render, staticRenderFns } from "./HeaderDropdown.vue?vue&type=template&id=4458e794&"
import script from "./HeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4458e794')) {
      api.createRecord('4458e794', component.options)
    } else {
      api.reload('4458e794', component.options)
    }
    module.hot.accept("./HeaderDropdown.vue?vue&type=template&id=4458e794&", function () {
      api.rerender('4458e794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/header/HeaderDropdown.vue"
export default component.exports